export default __webpack_public_path__ + "static/media/breast_plot.e648da00.png";